import * as React from 'react';
import PromoSection from './PromoSection';
import styled, { css } from 'styled-components';
import useIntercom from '~/hooks/useIntercom';
import AccountSwitcher from '~/components/organism/AccountSwitcher';
import { AuthContext } from '~/Root/Auth';
import Button from '~/components/atom/Button';
import JustificationContainer from '~/components/atom/JustificationContainer';
import { AUTH_PATHS } from '~/components/page/Auth/constants';

type Props = {
  children: React.ReactNode;
  bypassURLCheck?: boolean;
};
const AuthWrapperHOC: React.FCC<Props> = ({
  children,
  bypassURLCheck = false,
}) => {
  const isLoggedIn = React.useContext(AuthContext)?.isLoggedIn;

  const intercom = useIntercom();
  intercom.boot();

  if (
    bypassURLCheck === false &&
    (window.location.pathname.startsWith('/-/') ||
      window.location.pathname.startsWith('/-'))
  ) {
    return <>{children}</>;
  }

  return (
    <AuthWrapper>
      <PromoSection />
      <FormSection>
        {isLoggedIn && (
          <ToolsContainer gap="xs" align="center" justification="center">
            <AccountSwitcher variant="button" hideWhenSingleAccount />
            <Button
              icon="sign-out"
              ghost
              onClick={() => window.location.replace(AUTH_PATHS.LOGOUT)}
            />
          </ToolsContainer>
        )}

        {children}
      </FormSection>
    </AuthWrapper>
  );
};

const AuthWrapper = styled.div<{}>`
  display: flex;
  width: 100%;

  ${({ theme }) => css`
    background-color: ${theme.color('white')};
  `};
`;

const ToolsContainer = styled(JustificationContainer)(
  ({ theme }) => css`
    position: fixed;
    top: ${theme.space('base')};
    right: ${theme.space('base')};
  `,
);

const FormSection = styled.main<{}>(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100vh;
    min-width: 0;

    flex: 1 0 50%;
    transition: width 0.1s linear;
    padding: ${theme.space('m')} ${theme.space('l')};
    background: ${theme.gradient('page')};
    color: ${theme.color('white')};

    a,
    a:hover {
      color: ${theme.color('white')};
    }
  `,
);

export default AuthWrapperHOC;
